export const ReportAttendanceHostDetailText = {
  titleText: 'Absensi Report Host',
  filterStatusPlaceholder: 'Pilih Status',
  monthYearPickerPlaceholder: 'Pilih Bulan',
  buttonExportText: 'Export',
};
